<template>
  <div :class="$style.auth">
    <div class="pt-5 pb-5 d-flex align-items-end mt-auto">
      <img src="resources/images/truelife-logo.png" alt="Truelife" />
      <div class="air__utils__logo__text">
        <div class="air__utils__logo__name text-uppercase text-dark font-size-21">Truelife</div>
        <div class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6">Admin Dashboard</div>
      </div>
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 bg-white text-center formForgot" :class="$style.container">
      <div class="text-dark font-size-30 mb-4">Forgot Password</div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit" v-if="!isSuccess">
        <a-form-item>
          <a-input size="large" placeholder="Email Address" v-decorator="['email', { rules: [{ type: 'email', required: true, message: 'Please input your Email!' }] }]" />
        </a-form-item>
        <a-tag color="red" v-if="!isEmpty(errorMessage)">{{ errorMessage }}</a-tag>
        <a-button size="large" type="button" htmlType="submit" class="text-center btn btn-success w-100 font-weight-bold font-size-18">Reset my password</a-button>
      </a-form>
      <a-tag color="green" v-else style="font-size: 20px; padding: 5px;">Please check your email.</a-tag>
    </div>
    <div class="text-center font-size-18 pt-4 mb-auto">
      <a class="font-weight-bold text-blue" @click="handleGoBack"> <i class="fe fe-arrow-left align"></i> Go Back </a>
    </div>
    <div class="mt-auto pb-5 pt-5">
      <ul class="list-unstyled d-flex mb-2 flex-wrap justify-content-center" :class="$style.footerNav">
        <li>
          <a href="#">Terms of Use</a>
        </li>
        <li>
          <a href="#">Compliance</a>
        </li>
        <li>
          <a href="#">Support</a>
        </li>
        <li>
          <a href="#">Contacts</a>
        </li>
      </ul>
      <div class="text-gray-4 text-center">© {{ today | formatDate('YYYY') }} Truelife. All rights reserved.</div>
    </div>
  </div>
</template>
<script>
import AuthService from '@/services/AuthService';
import { get, isEmpty } from 'lodash';
export default {
  name: 'AirForgotPassword',
  data: function () {
    return {
      form: this.$form.createForm(this),
      isSuccess: false,
      errorMessage: '',
      today: new Date(),
    };
  },
  methods: {
    isEmpty,
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.$nprogress.start();
          try {
            await AuthService.forgotPassword(values.email);
            this.isSuccess = true;

            this.$nprogress.done();
            // this.$router.push({ name: 'dashboard' });
          } catch (error) {
            console.log({ error });
            // this.errorMessage = get(error, 'response.data.error', error.message);
            this.$nprogress.done();
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          }
        }
      });
    },
    handleGoBack() {
      this.$router.push({ name: 'signIn' });
    },
  },
};
</script>
<style lang="scss" module>
@import '@/components/Auth/style.module.scss';
</style>
